import React from 'react';
import { useUploadImageState } from './ImageUpload.state';
import { UploadImageView } from './ImageUpload.view';
import { IImageData } from '../type';

interface UploadImageProps {
    onImageSelect: (images: IImageData[]) => void;
}

const UploadImage: React.FC<UploadImageProps> = ({ onImageSelect }) => {
    const state = useUploadImageState(onImageSelect);

    return <UploadImageView {...state} />;
};

export default UploadImage;
